export const BATHROOM_PDP_ELEMENT_BLOCK = 'naboryVannDetail';

export const BATHROOM_PDP_CDN_PATH =
  'https://cdn.lemanapro.ru/lmru/image/upload/f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/bathroom-pdp';

export const BATHROOM_PDP_LANDING_NAME = 'bathroom-pdp';

export const BATHROOM_PDP_CATEGORY_ID = '553';

export const BATHROOM_PDP_NOT_FORGET_LIST = [
  '82277165',
  '82155257',
  '82804700',
  '82857029',
  '85106534',
  '89264127',
  '81979795',
  '85202049',
  '86483223',
  '84818669',
  '82801795',
  '83614391',
];
